<template>
  <div>
    <el-dialog
      title="设置奖品"
      :visible.sync="showDialog"
      width="70%"
      :close-on-click-modal="true"
      :close-on-press-escape="true"
      :before-close="cancelAction"
    >
      <el-main>
        <el-form
          ref="form"
          :rules="rules"
          :model="form"
          label-width="180px"
        >
          <el-form-item
            label="奖品名称"
            prop="item_name"
          >
            <el-input
              v-model="form.item_name"
              maxlength="50"
              show-word-limit
              placeholder="请输入奖品名称"
            />
          </el-form-item>
          <el-form-item
            label="奖品描述"
            prop="item_desc"
          >
            <el-input
              v-model="form.item_desc"
              maxlength="50"
              show-word-limit
              placeholder="请输入奖品描述"
            />
          </el-form-item>
          <!-- <el-form-item label="关键商品货号" prop="item_id">
            <el-input
              v-model="form.item_id"
              placeholder="请输入商品货号（用于核销扣减门店库存），可不填"
            ></el-input>
          </el-form-item> -->
          <!-- <el-form-item label="选择商品：" prop="item_id">
            <MeterGoodsManager :meters="subTaskForm" />
          </el-form-item> -->
          <el-form-item
            label="奖品图片："
            prop="imageUrl"
          >
            <SpOnlyPicSelect
              :image-url="imageUrl"
              @selectImage="selectImageData"
            />
          </el-form-item>
        </el-form>
      </el-main>
      <el-footer>
        <el-button @click="cancelAction">
          取消
        </el-button>
        <el-button
          type="primary"
          @click="handleConfirm"
        >
          确定
        </el-button>
      </el-footer>
    </el-dialog>
  </div>
</template>

<script>
// import MeterGoodsManager from '@/components/meterGoodsManager'

export default {
  name: 'SelectGift',
  // components: {
  //   MeterGoodsManager
  // },
  props: {
    selectGiftVisible: {
      type: Boolean,
      default: false
    },
    selectGiftData: {
      type: Array,
      default: () => {
        return []
      }
    }
  },
  data () {
    return {
      form: {
        item_name: '',
        item_desc: '',
        item_id: '',
        imageUrl: ''
      },
      rules: {
        item_name: [{ required: true, message: '请输入活动名称', trigger: 'blur' }]
      },
      imageUrl: '',
      subTaskForm: { goodsVisible: false, selectGoodsData: [], time_type: 3, pics: [] }
    }
  },
  computed: {
    showDialog () {
      return this.selectGiftVisible
    }
  },
  watch: {
    showDialog (newVal, oldVal) {
      if (newVal) {
        if (this.selectGiftData[1]) {
          this.form = this.selectGiftData[1]
          this.imageUrl = this.selectGiftData[1].imageUrl
        } else {
          this.form = {
            item_name: '',
            item_desc: '',
            item_id: '',
            imageUrl: ''
          }
        }
      } else {
        console.log(this.subTaskForm)
      }
    }
  },
  created () {},
  methods: {
    // 关闭模态框
    cancelAction () {
      this.$emit('selectGiftVisibleChange', [false])
    },
    handleConfirm () {
      this.$refs['form'].validate(async (valid) => {
        if (valid) {
          let params = this.form
          params.imageUrl = this.imageUrl
          params.data = this.subTaskForm
          this.subTaskForm = { goodsVisible: false, selectGoodsData: [], time_type: 3, pics: [] }
          this.$emit('selectGiftVisibleChange', [false, params])
        }
      })
    },
    selectImageData (selectdata) {
      this.imageUrl = selectdata
    }
  }
}
</script>

<style lang="scss" scoped>
.ml10 {
  margin-left: 10px;
}
</style>
